import "api/compliance/types";

import { IStyledSelectOption } from "ui/styled-select/types";
import { ITabsData } from "ui/tabs/types";

import { BusinessAccounts } from "./content/accounts";
import { IFreezeUnfreezeBusinessAccountFormData } from "./content/accounts/types";
import { BusinessAdmins } from "./content/admins";
import { BusinessDetails } from "./content/details";
import { BusinessEmployees } from "./content/employees";
import { ODP } from "./content/odp";
import { BusinessPayrolls } from "./content/payroll";
import { BusinessTransactions } from "./content/transactions";
import { BusinessYield } from "./content/yield";
import { IFreezeUnfreezeBusinessFormData } from "./types";

export enum BusinessDetailsTabStatus {
  details = "details",
  accounts = "accounts",
  transactions = "transactions",
  yield = "yield",
  admins = "admins",
  employees = "employees",
  "on-demand-pay" = "on-demand-pay",
  payroll = "payroll",
}

export const BUSINESS_DETAILS_TAB_CONTENT_LIST: ITabsData[] = [
  {
    value: BusinessDetailsTabStatus.details,
    content: <BusinessDetails />,
  },
  {
    value: BusinessDetailsTabStatus.accounts,
    content: <BusinessAccounts />,
  },
  {
    value: BusinessDetailsTabStatus.transactions,
    content: <BusinessTransactions />,
  },
  {
    value: BusinessDetailsTabStatus.yield,
    content: <BusinessYield />,
  },
  {
    value: BusinessDetailsTabStatus.admins,
    content: <BusinessAdmins />,
  },
  {
    value: BusinessDetailsTabStatus.employees,
    content: <BusinessEmployees />,
  },
  {
    value: BusinessDetailsTabStatus["on-demand-pay"],
    content: <ODP />,
  },
  {
    value: BusinessDetailsTabStatus.payroll,
    content: <BusinessPayrolls />,
  },
];

export const PAGE_LIMIT = 5;

export const businessDetailsTableColumn = [
  "Account Name",
  "Account Number",
  "Balance",
  "Account Type",
  "Status",
  "Freeze Status",
  "Date Created",
  "",
];

export const MIN_REASON_LENGTH = 5;
export const MIN_PHONE_LENGTH = 10;
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const OPTIONS_FOR_REASON_TO_DEACTIVATE_FREEZE_OR_CLOSE: IStyledSelectOption[] =
  [
    {
      label: "Reported Fraudulent Activity",
      value: "Reported Fraudulent Activity",
    },
    {
      label: "Suspicious Activity",
      value: "Suspicious Activity",
    },
    {
      label: "Customer's Request",
      value: "Customer's Request",
    },
    {
      label: "Security Concern/Compromised Account",
      value: "Security Concern/Compromised Account",
    },
    {
      label: "Multiple Chargeback Claim",
      value: "Multiple Chargeback Claim",
    },
    {
      label: "Others",
      value: "Others",
    },
  ];

export const OPTIONS_FOR_REASON_TO_ACTIVATE_OR_UNFREEZE: IStyledSelectOption[] =
  [
    {
      label: "Customer's Request",
      value: "Customer's Request",
    },
    {
      label: "Fraudulent Activity Issue Resolved",
      value: "Fraudulent Activity Issue Resolved",
    },
    {
      label: "Suspicious Activity Issue Resolved",
      value: "Suspicious Activity Issue Resolved",
    },
    {
      label: "Security Concern Issue Resolved",
      value: "Security Concern Issue Resolved",
    },
    {
      label: "Compromised Account Issue Resolved",
      value: "Compromised Account Issue Resolved",
    },
    {
      label: "Others",
      value: "Others",
    },
  ];

export const DEFAULT_FREEZE_UNFREEZE_FORM_DATA:
  | IFreezeUnfreezeBusinessFormData
  | IFreezeUnfreezeBusinessAccountFormData = {
  reason: "",
  attachment: null,
};
